var id = 0
  , px = Math.random();
module.exports = function(key){
  return 'Symbol('.concat(key === undefined ? '' : key, ')_', (++id + px).toString(36));
};


//////////////////
// WEBPACK FOOTER
// C:/Users/schulz/AppData/Roaming/npm/~/vbuild/~/core-js/library/modules/_uid.js
// module id = 158
// module chunks = 0